import ModalComponent from '../../components/ModalComponent';

interface Props {
  pageTitle: string
  open: boolean
  handleClose: () => void
  handleSave: () => void
  loadingSave?: boolean
}

const Index = (props: Props) => {
  const {
    open, pageTitle, handleClose, handleSave, loadingSave,
  } = props;

  return (
    <ModalComponent
      title="ページ複製"
      confirmButtonText="複製する"
      onConfirm={handleSave}
      show={open}
      closeModal={handleClose}
      centered
      animation={false}
      disabled={loadingSave}
      loading={loadingSave}
    >
      <p className="mb-0">
        「
        {pageTitle}
        」を複製しますか？
      </p>
    </ModalComponent>
  );
};

export default Index;
